module.exports = __webpack_public_path__ + "media/peutz jeghers syndrome.c2a16d35.wav";